import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import FeedsList from '../components/FeedsList';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { classes } from '../components/Button';
import { Feed } from '../feed';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';

const newFeed: Feed = {
  id: null,
  name: '',
  visible_from: new Date(),
  visible_in: [],
  visible_worldwide: false,
  data: [],
  active: false,
};

const feeds = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/feeds',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function Feeds() {
  const context = React.useContext(ProfileContext);
  const state = feeds(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Discover" subtitle="Manage the feed for Filtru Discover">
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/feeds/edit/new',
            state: {
              feed: { ...newFeed },
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <FeedsList feeds={state.data || []} />
    </Page>
  );
}
